import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/page-header';
import { Routes } from 'src/components/common/router/constants';
import { UserMergeRequestItem } from 'src/components/user-merge-requests/item/item';
import { UserMergeRequestDetailsItem } from 'src/components/user-merge-requests/item/types';
import { useUserMergeRequest } from 'src/hooks/query/user-merge-requests/use-user-merge-request';

export const ProfileUserMergeRequestItemPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-profile.breadcrumbs',
  });

  const { entity, loading } = useUserMergeRequest({ id: id as string });
  const title = t('create-user-merge-request');

  const breadCrumbsProps = {
    items: [
      { label: t('your-profile'), url: Routes.profile.path },
      { label: title },
    ],
  };

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      {!loading && (
        <UserMergeRequestItem
          entity={entity as UserMergeRequestDetailsItem}
          hiddenFields={['userId', 'responseNotes']}
          onFinished={() => navigate(Routes.profile.path)}
        />
      )}
    </>
  );
};
